<template>
  <div>
    <app-contentpageheader>
      <b-img
        slot="entrySectionImage"
        fluid
        alt="Responsive image"
        :src="backgroundImg"
      />
      <h3 slot="entrySectionText">Oleje</h3>
    </app-contentpageheader>
    <app-oil />
    <app-footer />
  </div>
</template>
<script>
import ContentPageHeader from "../../components/common/ContentPageHeader.vue";
import Oil from "../../components/offer/Oil.vue";
import Footer from "../../components/common/Footer.vue";
export default {
  data() {
    return {
      backgroundImg: require("../../assets/offer/olej.jpg")
    };
  },
  components: {
    "app-oil": Oil,
    "app-footer": Footer,
    "app-contentpageheader": ContentPageHeader
  }
};
</script>
